import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";
import { useCustomQuery } from "utilities/hookutils";

interface Props extends DropdownProps<server.dto.BankAccountSmall> {
  filterByBookkeepingId?: number
}

const BankAccountDropdown = (props: Props) => {
  const bankAccountApi = useCustomQuery({
    queryKey: ["bankAccount", props.filterByBookkeepingId],
    queryFn: async () => window.CoreApi.BankAccount.ListBankAccountSmall({
      bookkeepings: [props.filterByBookkeepingId],
      page: 1,
      perPage: 500,
    }).then(res => res.data.data),
    enabled: !props.options,
    initialData: props.options
  });

  const options = props.options ? props.options : bankAccountApi.data;

  return <BaseReactSelectDropdown
    value={props.value}
    onChange={props.onChange}
    options={options}
    getLabel={bankAccount => bankAccount.title}
    getSubLabel={bankAccount => bankAccount.beneficiaryName}
    getValue={bankAccount => bankAccount.bankAccountId}
    excludeKeys={props.excludeKeys}
    config={{
      isSearchable: true,
      placeholder: RESX.GeneralLabels.SearchByName,
      ...props.config
    }}
  />;
};

export default BankAccountDropdown;